import { NodeID } from '@builder/schemas';

import { DashboardState } from 'src/store/common';

export const openAsRoot = (dashboardState: DashboardState, nodeID: NodeID): DashboardState => {
  return { ...dashboardState, openAsRootNode: { nodeID } };
};
